import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { getAllContactsAPI, headCells, TableData } from "../types";
import NoResultFoundFilters from "../../../../atoms/noResultsFilters";
import { Box, Skeleton } from "@mui/material";
import TableViewCommon from "../../../../molecules/table-view-common";
import TableCellsRow from "./tableCells";
import { formatDataClientTable } from "../helper";
import PaginationComponent from "../../../../atoms/pagination";

type Props = {
    apiData: getAllContactsAPI | null;
    isFilter: boolean;
    openEditContact: (id: number) => void;
    page: number;
    totalPages: number;
    totalResult: number;
    paginationHandler: (event: React.ChangeEvent<unknown>, value: number) => void;
    dropdownFilterProps: {
        filterValue: string;
        setFilterPayload: (value: string) => void;
    };
};

const ContactTable = ({ apiData, isFilter, openEditContact, page, totalPages, totalResult, paginationHandler, dropdownFilterProps
}: Props) => {

    const dataList: any = Array.isArray(apiData?.data) ? apiData?.data : apiData
    return (
        <>
            {(apiData?.success || (dataList?.length ?? 0) > 0) ? (
                <>
                    {dataList.length > 0 ? (
                        <Grid container>
                            <TableViewCommon<TableData>
                                rows={formatDataClientTable(dataList || [])}
                                totalSelected={0}
                                title={``}
                                headCells={headCells}
                                isSelected={false}
                                selectAllowed={(row) => false}
                                handleTableRowClick={(e, row) => { }}
                                tableCells={(row, labelId, isSelected) => {
                                    return (<TableCellsRow
                                        key={row.id}
                                        row={row}
                                        labelId={labelId}
                                        isSelected={isSelected}
                                        openEditContact={openEditContact}
                                    />);
                                }}
                                isItemSelected={(id) => false}
                                handleSelectAllClick={(e) => { }}
                                rowsPerPageOptions={[12, 24, 48, 96]}
                                rowsPerPageDefault={parseInt(dropdownFilterProps.filterValue)}
                                defaultPage={page - 1}
                                handleChangePageFn={(newPage) => paginationHandler({} as React.ChangeEvent<unknown>, newPage + 1)}
                                handleChangeRowsPerPageFn={(newRowsPerPage) => dropdownFilterProps.setFilterPayload(newRowsPerPage.toString())}
                                totalRows={totalResult}
                                isAsync={true}
                                containerSx={{ maxHeight: 'none', minHeight: "55vh", overflowY: "auto" }}
                            />
                        </Grid>
                    ) : (
                        <>
                            {!isFilter ? (
                                <Grid container spacing={2}>
                                    <Grid
                                        item
                                        xs={12}
                                        display={"flex"}
                                        alignItems={"center"}
                                        justifyContent={"center"}
                                        mt={4}
                                    >
                                        <Typography
                                            variant="h2"
                                            sx={{ fontSize: "20px", fontWeight: "500" }}
                                        >
                                            No Client Contacts Found
                                        </Typography>
                                    </Grid>
                                </Grid>
                            ) : (
                                <NoResultFoundFilters />
                            )}
                        </>
                    )}
                </>
            ) : (
                <>
                    {[1, 2, 3, 4, 5].map(() => (
                        <>
                            <Grid item xs={2} sx={{ padding: "10px 5px", paddingLeft: "1rem" }}>
                                <Skeleton />
                            </Grid>
                            <Grid item xs={2} sx={{ padding: "10px 5px" }}>
                                <Skeleton />
                            </Grid>
                            <Grid item xs={2} sx={{ padding: "10px 5px" }}>
                                <Skeleton />
                            </Grid>
                            <Grid item xs={2} sx={{ padding: "10px 5px" }}>
                                <Skeleton />
                            </Grid>
                            <Grid item xs={2} sx={{ padding: "10px 5px" }}>
                                <Skeleton />
                            </Grid>
                            <Grid item xs={2} sx={{ padding: "10px 5px" }}>
                                <Skeleton />
                            </Grid>
                        </>
                    ))}
                </>
            )}
        </>
    );
};

export default ContactTable;
